import { render, staticRenderFns } from "./TreeCategoryRoot.vue?vue&type=template&id=4c522cbc&scoped=true"
import script from "./TreeCategoryRoot.vue?vue&type=script&lang=js"
export * from "./TreeCategoryRoot.vue?vue&type=script&lang=js"
import style0 from "./TreeCategoryRoot.vue?vue&type=style&index=0&id=4c522cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c522cbc",
  null
  
)

export default component.exports